export default {
  black: 'black-hover',
  blue: 'blue-hover',
  light: 'light-hover',
  peach: 'peach-hover',
  purple: 'purple-hover',
  aqua: 'aqua-hover'
}
